import Scroll from './common/scroll';
import Slider from './common/slider';
import Modal from './common/modal';
import Movie from './common/movie';
import Datenav from './common/datenav.es6';

const scroll = new Scroll();
const slider = new Slider();
const modal = new Modal();
const movie = new Movie();
const datenav = new Datenav();